import "./ArtistModal.scss";

import { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { api } from "../../../utils/api";
import { useCurrentUser } from "../../../UserProvider";
import { useArtistContext } from "../ArtistPageContext";

export default function DisplayNameModal({ show, handleClose }) {
  const { artist, setArtist } = useArtistContext();
  const { refreshUser } = useCurrentUser();
  const navigate = useNavigate();
  const [value, setValue] = useState(artist.display_name);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setError(null);
    setSaving(true);
    try {
      const { data: updatedArtist } = await api.put(`/profiles/${artist.id}`, { display_name: value });
      setArtist(updatedArtist);
      await refreshUser();
      handleClose();
      navigate(`/p/${updatedArtist.display_name}`);
    } catch {
      setError("That URL is already taken. Please try a different one.");
    } finally {
      setSaving(false);
    }
  };

  const handleExited = () => {
    setValue(artist.display_name);
    setError(null);
  };

  return (
    <Modal className="__artist-modal" show={ show } onHide={ handleClose } onExited={ handleExited } centered>
      <Modal.Header closeButton>
        <Modal.Title>Artist Page URL</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          value={ value }
          onChange={ (e) => setValue(e.target.value) }
        />
        { error && (
          <div className="text-danger mt-2">{ error }</div>
        ) }
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-tertiary" onClick={ handleClose } disabled={ saving }>Cancel</Button>
        <Button className={ `ppy-btn ppy-btn-primary${ saving || !value || value === artist.display_name ? " disabled" : "" }` } onClick={ handleSave } disabled={ saving || !value || value === artist.display_name }>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
